import { Checkbox, Radio, Input } from "antd";
import CustomInputNumber from "../../CustomInputNumber";
import CustomInputNumberV2 from "../../CustomInputNumberV2";

export default function FoodTaxAndDiscount({
                                             records: {
                                               isVatApplicable,
                                               setIsVatApplicable,
                                               isDiscountApplicable,
                                               setIsDiscountApplicable,
                                               isSupplementaryDutyApplicable,
                                               setIsSupplementaryDutyApplicable,
                                               supplementaryDuty,
                                               setSupplementaryDuty,
                                             },
                                           }) {
  const handleSDChange = (value) => {
    setIsSupplementaryDutyApplicable(value);

    // 🔥 IMPORTANT: Reset SD value when No is selected
    if (!value) {
      setSupplementaryDuty(0);
    }
  };
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-6 mb-12">

      {/* VAT & Discount Section */}
      <div className="border rounded-xl p-6">
        <div className="flex flex-col gap-4">

          <Checkbox
            checked={isVatApplicable}
            onChange={(e) => setIsVatApplicable(e.target.checked)}
          >
            <span className="font-medium">VAT Applicable</span>
          </Checkbox>

          <Checkbox
            checked={isDiscountApplicable}
            onChange={(e) => setIsDiscountApplicable(e.target.checked)}
          >
            <span className="font-medium">Discount Applicable</span>
          </Checkbox>

        </div>
      </div>

      {/* Supplementary Duty Section */}
      <div className="border rounded-xl p-6">
        <div className="flex flex-col gap-4">

          <div className="flex items-center justify-between">
            <p className="font-medium">SD Applicable</p>

            <Radio.Group
              value={isSupplementaryDutyApplicable}
              onChange={(e) => handleSDChange(e.target.value)}
            >
              <Radio value={true}>Yes</Radio>
              <Radio value={false}>No</Radio>
            </Radio.Group>
          </div>
          
          <CustomInputNumberV2 
            value={supplementaryDuty}
            setValue={setSupplementaryDuty}
            addonAfter="%"
            placeholder={'0'}
            min={-1}
            max={100}
            disabled={!isSupplementaryDutyApplicable}
            isDecimalAllowed={true}
          />

        </div>
      </div>

    </div>
  );
}